


























































































































































































































































import { Component, Vue, Inject } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import Appconst from '../../../../lib/appconst';
import DownloadList from "../../../../components/tools/downloadList.vue";
@Component({
	name:'docManageDetail',
	components: {
		DownloadList
	}
})
export default class DocManageDetail extends AbpBase  {
	initData:any = {
		id: 0,
		detail: {
			creatorDep: {},
			creatorUser: {},
			attachs: [],
			ticks: []
		},
		lookDetail: {
			creatorUser: {},
			meetingImages: [],
			meetingAttachs: []
		},
		cacheDetails: {},
		spinShow: true,
		previewUrl: '',
	    previewVisible: false,
	    showModal: false,
	    showMeetingModal: false,
	    showFeedbackModal: false,
	    meetingSubmitLoading: false,
	    feedbackSubmitLoading: false,
	    fileUrl: Appconst.fileUrl,
	    uploadFilePreview: []
	}
	formData:any = {
		id: '',
		meetingDt: '',
		meetingAddress: '',
		meetingSummary: '',
		meetingImages: [],
		meetingAttachs: []
	}
	ruleValidate:any = {
		meetingDt: [
			{ required: true, type: 'date', message: '请选择会议时间', trigger: 'blur' }
		],
		meetingAddress: [
			{ required: true, message: '请填写会议地点', trigger: 'blur' }
		],
		meetingSummary: [
			{ required: true, message: '请填写会议纪要', trigger: 'blur' }
		],
		meetingImages: [
			{ required: true, type: 'array', message: '请上传会议照片' }
		],
		meetingAttachs: [
			{ required: true, type: 'array', message: '请上传会议签到表' }
		],
	}
	feedbackData:any = {
		id: '',
		tickContent: '',
		attachs: []
	}
	feedbackValide:any = {
		tickContent: [
			{ required: true, message: '请填写反馈内容', trigger: 'blur' }
		]
	}
	tableData:any = {
		columns: [
			{
				title: '文件反馈情况',
				children: [
					{
						title: '部门（实体）',
						key: 'dep',
						render: (h:any, params:any) => {
							if(params.row.creatorDep){
								return h('span', params.row.creatorDep.displayName);
							}
							return h('span', '');
						}
					},
					{
						title: '反馈人',
						key: 'name',
						render: (h:any, params:any) => {
							if(params.row.creationTime) {
								return h('span', params.row.creatorUser.name);
							}else{
								return h('span', {
									style: {
										color: 'red'
									}
								}, '未反馈');
							}
						}
					},
					{
						title: '反馈时间',
						key: 'time',
						render: (h:any, params:any) => {
							return h('span', params.row.creationTime ? this.formatDate(params.row.creationTime) : '--');
						}
					},
					{
						title: '操作',
						key: 'action',
						render: (h:any, params:any) => {
							if(!!params.row.creationTime) {
								let btns:any = [
									h('Button', {
										props: {
											type: 'info',
											size: 'small'
										},
										on: {
											click: () => {
												this.handleLoadDetail(params.row.id);
											}
										}
									}, '查看反馈材料')
								];
								if(this.initData.detail.creatorUserId == params.row.creatorUserId) {
									btns.push(h('Button', {
										props: {
											type: 'success',
											size: 'small'
										},
										style: {
											marginLeft: '10px'
										},
										on: {
											click: () => {
												this.handleCreateEdit(params.row.id);
											}
										}
									}, '编辑'));
									btns.push(h('Button', {
										props: {
											type: 'error',
											size: 'small'
										},
										style: {
											marginLeft: '10px'
										},
										on: {
											click: () => {
												this.handleDelete(params.row.id);
											}
										}
									}, '删除'));
								}
								return h('div', btns);
							}else{
								// if(this.initData.detail.creatorUserId == params.row.creatorUserId) {
									return h('Button', {
										props: {
											type: 'primary',
											size: 'small'
										},
										on: {
											click: () => {
												if(this.initData.detail.fileType == 1) {
													this.initData.showMeetingModal = true;
												}else{
													this.initData.showFeedbackModal = true;
												}
											}
										}
									}, '提交材料')
								// }else{
								// 	return h('span', '');
								// }
							}
						}
					}
				]
			}
		]
	}
	init() {
		Ajax.get('/api/services/app/Matter/GetMatterDetailAsync', {params: {id: this.initData.id}}).then((res:any)=>{
        	this.initData.detail = res.data.result;
        	this.initData.spinShow = false;
        })
	}
	//照片上传        
    handleView (url:any) {
        this.initData.previewUrl = this.initData.fileUrl + url;
        this.initData.previewVisible = true;
    }
    handleSuccess (res:any, file:any) {
    	let url:any = res.result;
        let arr:any = [];
        this.initData.uploadFilePreview.forEach((item:any) => {
        	if(item.name == file.name) {
        		url = item.url;
        	}else{
        		arr.push(item);
        	}
        })
        this.initData.uploadFilePreview = arr;
    	this.formData.meetingImages.push({result: res.result, url: url});
    }
    handleFormatError (file:any) {
        this.$Notice.warning({
            title: '图片格式错误',
            desc: '图片 ' + file.name + ' 格式错误, 请选择jpg或者png格式的图片'
        });
    }
    handleMaxSize (file:any) {
        this.$Notice.warning({
            title: '图片大小错误',
            desc: '图片 ' + file.name + ' 超过2M限制'
        });
    }
    handleBeforeUpload (obj:any) {
        if(!this.formData.meetingImages) return;
        const check = this.formData.meetingImages.length < 5;
        if (!check) {
            this.$Notice.warning({
                title: '上传图片数量需小于五张'
            });
        }
        if(check) {
        	if((window as any).createObjectURL != undefined) {
        		obj.url = (window as any).createObjectURL(obj);
        	}else if((window as any).URL != undefined) {
        		obj.url = (window as any).URL.createObjectURL(obj);
        	}else if((window as any).webkitUrl != undefined){
        		obj.url = (window as any).webkitUrl.createObjectURL(obj);
        	}
        	this.initData.uploadFilePreview.push({name: obj.name, url: obj.url});
        }
        return check;
    }
    formatDate(d:any) {
    	if(!d) return '';
    	if(typeof d == 'string') {
    		d = new Date(d);
    	}
    	return d.getFullYear() +'-'+ (d.getMonth() + 1) +'-'+ d.getDate();
    }
    // 
    handleMeetingSubmit() {
		this.formData.meetingAttachs = (this as any).$refs.uploadFile.fileList;
		console.log(this.formData);
    	(this.$refs.meetForm as any).validate(async (valid:boolean)=>{
            if(valid){
  				let params:any = {
            		meetingDt: this.formatDate(this.formData.meetingDt),
					meetingAddress: this.formData.meetingAddress,
					meetingSummary: this.formData.meetingSummary,
					meetingImages: [],
					meetingAttachs: []
            	}
  				// 过滤已上传的照片
  				this.formData.meetingImages.forEach((item:any) => {
  					if(item.result) {
  						params.meetingImages.push(item.result);
  					}
  				})
    			// 过滤已上传的文件
    			let files:any = (this as any).$refs.uploadFile.fileList || [];
    			files.forEach((item:any) => {
    				if(item.response && item.response.result) {
    					params.meetingAttachs.push(item.response.result);
    				}
    			})
    			
  				this.initData.meetingSubmitLoading = true;
  				// 编辑
  				if(this.formData.id) {
  					params.id = this.formData.id;
  					await Ajax.put('/api/services/app/Matter/UpdateMatterTickForStudyAsync', params).then((res:any)=>{
		                this.$Message.success('编辑成功!');
		                this.initData.meetingSubmitLoading = false;
		                this.initData.showMeetingModal = false;
		                this.initData.cacheDetails[params.id] = undefined;
						this.init();
						this.handleClearMeetingForm(false);//重置表单
		            }).catch(() => {
		            	this.initData.meetingSubmitLoading = false;
		            })
  				}else{
  					// 新增
  					params.matterId = this.initData.id;
  					await Ajax.post('/api/services/app/Matter/CreateMatterTickForStudyAsync', params).then((res:any)=>{
		                this.$Message.success('提交成功!');
		                this.initData.meetingSubmitLoading = false;
		                this.initData.showMeetingModal = false;
	                	this.init();
						this.handleClearMeetingForm(false);//重置表单
		            }).catch(() => {
		            	this.initData.meetingSubmitLoading = false;
		            })
  				}
            }
        })
	}
	//重置表单
    handleClearMeetingForm(flog:any) {
    	if(!flog) {
    		this.initData.showMeetingModal = false;
    		this.formData.id = '';
    		(this as any).$refs.meetForm.resetFields();
    	}
    }
    async handleFeedbackSubmit() {
    	let params:any = {
			tickContent: this.feedbackData.tickContent,
			attachs: []
    	}
		
		// 过滤已上传的文件
		let files:any = (this as any).$refs.uploadFeedbackFile.fileList || [];
		files.forEach((item:any) => {
			if(item.response && item.response.result) {
				params.attachs.push(item.response.result);
			}
		})
		
		this.initData.feedbackSubmitLoading = true;
		if(this.feedbackData.id) {
			// 编辑
			params.id = this.feedbackData.id;
			await Ajax.put('/api/services/app/Matter/UpdateMatterTickForTranslationAsync', params).then((res:any)=>{
	            this.$Message.success('编辑成功!');
	            this.initData.feedbackSubmitLoading = false;
	            this.initData.showFeedbackModal = false;
	            this.initData.cacheDetails[params.id] = undefined;
	        	this.init();
	        }).catch(() => {
	        	this.initData.feedbackSubmitLoading = false;
	        })
		}else{
			// 添加
			params.matterId = this.initData.id;
			await Ajax.post('/api/services/app/Matter/CreateMatterTickForTranslationAsync', params).then((res:any)=>{
	            this.$Message.success('提交成功!');
	            this.initData.feedbackSubmitLoading = false;
	            this.initData.showFeedbackModal = false;
	        	this.init();
	        }).catch(() => {
	        	this.initData.feedbackSubmitLoading = false;
	        })
		}
    }
    handleClearFeedbackForm(flog:any) {
    	if(!flog) {
    		this.initData.showFeedbackModal = false;
    		this.feedbackData.id = '';
    		(this as any).$refs.feedbackForm.resetFields();
    	}
    }
    handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此反馈记录？',
            onOk: () => {
                Ajax.delete('/api/services/app/Matter/DeleteTickAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.init();
	            })
            }
        });
    }
    async handleDetailFile(file:any, fileList:any) {
    	this.$Modal.confirm({
            title:　'删除',
            content: '确定删除吗？',
            okText: '确定',
            cancelText: '取消',
            onOk: async ()=>{
            	if(file.deletetype == 'image') {
            		this.formData.meetingImages.splice(file.index, 1);
            	}
            	if(!file.id) return;
		    	await Ajax.delete('/api/services/app/Matter/DeleteTickFileAsync', {params: {id: file.id}}).then((res:any)=>{
		    		this.$Message.success('删除成功!');
		       })
            }
        })
    	
    }
    async handleLoadDetail(id:any) {
    	if(this.initData.cacheDetails[id]) {
    		this.initData.lookDetail = this.initData.cacheDetails[id];
    		this.initData.showModal = true;
    		return;
    	}
    	await Ajax.get('/api/services/app/Matter/GetMatterTickDetailAsync', {params: {id: id}}).then((res:any)=>{
    		this.initData.lookDetail = res.data.result.study || res.data.result.translation;
    		this.initData.cacheDetails[id] = this.initData.lookDetail;
    		this.initData.showModal = true;
        })
    }
    // 同步学习宣贯类文件表单数据
    asyncMeetingFormData(params:any) {
		this.formData.id = params.id;
		this.formData.meetingDt = new Date(params.meetingDt);
		this.formData.meetingAddress = params.meetingAddress;
		this.formData.meetingSummary = params.meetingSummary;
		this.formData.meetingImages = params.meetingImages.map((item:any) => {
			return {
				id: item.id,
				url: item.url
			}
		})
		this.formData.meetingAttachs = params.meetingAttachs.map((item:any) => {
			return {
				id: item.id,
				name: item.attachName,
				url: item.url
			}
		})
		this.initData.showMeetingModal = true;
    }
    // 同步事务性文件
    asyncFeedbackFormData(params:any) {
		this.feedbackData.id = params.id;
		this.feedbackData.tickContent = params.tickContent;
		this.feedbackData.attachs = params.attachs.map((item:any) => {
			return {
				id: item.id,
				name: item.attachName,
				url: item.url,
				fileId: item.fileId
			}
		})
		this.initData.showFeedbackModal = true;
    }
    async handleCreateEdit(id:any) {
    	if(this.initData.cacheDetails[id]) {
    		if(this.initData.detail.fileType == 1) {
    			this.asyncMeetingFormData(this.initData.cacheDetails[id]);
    		}else{
    			this.asyncFeedbackFormData(this.initData.cacheDetails[id]);
    		}
    		return;
    	}
    	await Ajax.get('/api/services/app/Matter/GetMatterTickDetailAsync', {params: {id: id}}).then((res:any)=>{
    		this.initData.cacheDetails[id] = res.data.result.study || res.data.result.translation;
    		if(this.initData.detail.fileType == 1) {
    			this.asyncMeetingFormData(this.initData.cacheDetails[id]);
    		}else{
    			this.asyncFeedbackFormData(this.initData.cacheDetails[id]);
    		}
        })
    }
	mounted() {
		this.initData.id = this.$root.$route.params.id;
		this.formData.meetingAttachs = (this as any).$refs.uploadFile.fileList;
		this.feedbackData.attachs = (this as any).$refs.uploadFeedbackFile.fileList;
		this.init();
	}
}
